import { ROLES } from 'config/roles';
import { getUserRolesApi } from '../services/openClaimService';
import { IRoute } from '../routes/data';

export function translateRole(role: string): string {
  const lowerCaseRole = role.toLocaleLowerCase();
  const managementRoles = [
    'usuário extranet',
    'administrador ti',
    'funcionário corporativo geral',
    'usuário sistemas',
  ];

  const franchiseeRoles = [
    'atendente de venda direta',
    'back office de venda direta',
    'caixa de venda direta',
    'caixa loja',
    'consultor de vendas',
    'estoquista',
    'estoquista de venda direta',
    'fornecedor',
    'franchising - gestão de operadores',
    'franqueado',
    'funcionário interno do cp',
    'gerente de loja',
    'gerente de venda direta',
    'gestão de operadores',
    'makeup expert',
    'multiplicador de treinamento',
    'operador',
    'operador regionais',
    'representante legal',
    'sucessor',
    'supervisor de campo',
    'supervisor de loja',
  ];

  if (managementRoles.includes(lowerCaseRole)) return ROLES.MANAGEMENT;
  if (franchiseeRoles.includes(lowerCaseRole)) return ROLES.FRANCHISEE;
  return 'Undefined';
}

export async function ingresseRole(): Promise<string> {
  let userroles = sessionStorage.getItem('userIngresseRole') || '';

  if (!userroles) {
    const { data, status } = await getUserRolesApi();
    if (status === 200) {
      [userroles] = data.response.roles;
      sessionStorage.setItem('userIngresseRole', userroles);
    }
  }
  return Promise.resolve(userroles);
}

export async function getRoutes(ROUTES: IRoute[]): Promise<IRoute[]> {
  const userRole = await ingresseRole();
  const routes = ROUTES.filter(route => {
    return route.roles.some(role => role === userRole);
  });
  return Promise.resolve(routes);
}
